/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum QuoteExposureActEnum {
    STATE_FEDERAL_ACT = 1,
    USL_AND_H = 2,
    FEDERAL_MINE_ACT_ONLY = 3,
    FEDERAL_MINE_ACT_AND_OR_STATE_ACT = 4,
    OIL_AND_OTHER_MINERALS_OVER_WATER = 5,
    EXCLUDING_MEDICAL = 6,
    EXCESS_BENEFITS_COVERAGE = 7,
    USL_AND_H_FOR_OIL_GAS_OR_OTHER_ON_OVER_WATER = 8,
    MARITIME_COVERAGE = 9,
    VOLUNTARY_COMPENSATION_COVERAGE = 10,
}
